import { type RefObject, useLayoutEffect } from "react";
import type { ImperativePanelHandle } from "react-resizable-panels";

interface UsePanelResizeProps {
    panelRef: RefObject<ImperativePanelHandle | null>;
    size: number;
    dependencies?: [unknown, unknown];
}

export const usePanelResize = ({ panelRef, size, dependencies }: UsePanelResizeProps) => {
    const dep1 = dependencies?.[0];
    const dep2 = dependencies?.[1];

    useLayoutEffect(() => {
        try {
            panelRef.current?.resize(size);
        } catch (error) {
            console.error("Error resizing panel:", error);
        }
    }, [size, panelRef, dep1, dep2]);
};
